import { render, staticRenderFns } from "./udiFilwDown.vue?vue&type=template&id=b9ee3778&scoped=true"
import script from "./udiFilwDown.vue?vue&type=script&lang=js"
export * from "./udiFilwDown.vue?vue&type=script&lang=js"
import style0 from "./udiFilwDown.vue?vue&type=style&index=0&id=b9ee3778&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ee3778",
  null
  
)

export default component.exports